import angular from "angular";

angular
	.module('app')
	.component('notificationCourseMoveToArchive', {
		template: require('./notification-course-move-to-archive.html'),
		controller: ['$http', controller],
		bindings: {
			resolve: '<',
			close: '&',
			dismiss: '&'
		}
	});

function controller($http) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
		$ctrl.notify = $ctrl.resolve.notification;
	};
}